import { render } from "./media-carousel.vue?vue&type=template&id=0bebe30f"
import script from "./media-carousel.vue?vue&type=script&lang=js"
export * from "./media-carousel.vue?vue&type=script&lang=js"

import "./media-carousel.vue?vue&type=style&index=0&id=0bebe30f&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__